// encryption.js
import CryptoJS from 'crypto-js';

export const encrypt = (data) => {
  return CryptoJS.AES.encrypt(data, process.env.REACT_APP_SECRET_KEY).toString();
};

export const decrypt = (encryptedData) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, process.env.REACT_APP_SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const makeUrlSafe = (base64String) => {
  return base64String
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

// Función para revertir el proceso URL-safe
export const revertUrlSafe = (urlSafeString) => {
  let base64String = urlSafeString
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  while (base64String.length % 4) {
    base64String += '=';
  }
  return base64String;
};



// --- Helpers reutilizables ---
export const toBase64 = (str) => {

  if (typeof btoa === "function") {
    /*
      btoa es una función que viene por defecto en el navegador, con ella se 
      puede codificar en Base64, por eso se pregunta si existe.
    */
    const bytes = new TextEncoder().encode(str);
    /*
      Aquí creamos un objeto para convertir el texto en el formato de bytes universal
      UTF-8.
      encode(str) convierte la cadena str en un Uint8Array 
      (un arreglo de enteros sin signo de 8 bits, es decir, cada entero entre 0 y 255).
    */
    let binary = "";
    for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
    /*
      Aquí recorremos el arreglo de bytes para convertir cada byte en caracteres.
    */
    return btoa(binary); // Retornamos la cadena de texto
  }

  // Node
  /*
    Ahora, si no existe la función btoa, usamos el buffer de Node.js.
    Este no convierte a decimal como la función btoa, sino a hexadecimal, 
    y de ahí se convierten a caracteres en Base64, ejemplo: SG9sYQ==.
  */
  return Buffer.from(str, "utf-8").toString("base64");
}

export const toBase64Url= (str) =>  { // codifica
  // Base64URL = reemplaza caracteres y quita el padding
  return toBase64(str)
    .replace(/\+/g, "-") // Reemplazamos el + por el -
    .replace(/\//g, "_") // Reemplazamos el / por el _
    .replace(/=+$/, ""); // Reemplazamos el = por sinespacios
}

export const  normalizeBase64ForDecode =  (b64)   =>  { //decpdifica
  const clean = (b64 ?? "").trim(); 
  /* 
  Preguntamos si la candena es nula o undefined,
  nos aseguramos de que no tenga espacios
   */
  if (!clean) return ""; 
  // Si la entrada de caracteres es nula, devolvemos vacio enseguida


  const normalized = clean.replace(/-/g, "+").replace(/_/g, "/");  
  // Convierte de URL a estándar

  // Rellena padding si falta
  const pad = normalized.length % 4;
  //Siempre en la posicion numero 4 se hace el reemplzao del caracter
  
  return pad ? normalized + "=".repeat(4 - pad) : normalized;
  //si el paddin es cero esta bien, sino se agregan iguales al final
  //	Si pad = 2 → 4 - 2 = 2 → agrega "==".
  //	Si pad = 3 → 4 - 3 = 1 → agrega "=".
  //	Si pad = 3 → 4 - 4 = 0 → agrega "".
}

export const  fromBase64Url = (b64) =>  {
  const padded = normalizeBase64ForDecode(b64); 
  /* padded, tiene los caracteres decodificados */
  if (!padded) return ""; // si padded esta vacio retornamos vacio

  let bytes;// declaramos una variable de tipo bloque
  if (typeof atob === "function") { // preguntamos si la funcion atob la tiene el navegador
    let binary;//variable de tipo bloque
    try {
      binary = atob(padded);//aqui validamos que la cadena sea de formato Base64
    } catch {
      throw new Error("Base64 inválido.");
    }
    bytes = new Uint8Array(binary.length); 
    // convertimos la cadena en bytes que almacena decimales de 0 a 255, enteros.

    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    //Guardamos los codigos numericos en string  de binarios

  } else {
    bytes = Uint8Array.from(Buffer.from(padded, "base64"));
    //Guardamos los codigos numericos en string de binarios
  }

  return new TextDecoder("utf-8", { fatal: false }).decode(bytes);
  // decodificamos de codigos numericos a letras
}